<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">POI管理</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="名称" prop="EqName">
            <el-input v-model="EqName" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="EqType" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in EqTypeArr"
                :key="item.ItemKey"
                :label="item.Description"
                :value="item.ItemValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-col>
              <el-form-item label class="right">
                <el-button @click="onSearch">查 询</el-button>
                <el-button @click="onCancel">清 理</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column prop="DeviceName" label="名称"></el-table-column>
              <el-table-column prop="DeviceNo" label="编号">
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.JsonExtend == null
                        ? ""
                        : JSON.parse(scope.row.JsonExtend).DeviceNo
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="RegionId"
                label="区域"
                :formatter="RegionNumToNameConverter"
              ></el-table-column>
              <el-table-column
                prop="DeviceType"
                label="类型"
                :formatter="EqTypeNumToNameConverter"
              ></el-table-column>
              <el-table-column prop="Name" label="姓名">
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.JsonExtend == null
                        ? ""
                        : JSON.parse(scope.row.JsonExtend).Name
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="LinkPhone" label="电话">
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.JsonExtend == null
                        ? ""
                        : JSON.parse(scope.row.JsonExtend).LinkPhone
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "POIManagerView",
  controller: "UI",
  action: "POIManagerView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      EqName: "",
      EqType: "",
      EqTypeArr: [],
      EqRegionArr: [],
    };
  },
  created: function() {
    this.getRegionInfo();
    this.getPOIType();
  },
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "POI查询";
    this.logInfo.LogMessage = "POI查询";
    this.logInfo.ModuleName = "设备管理";
    this.logInfo.PageName = "POI管理列表";
    this.addOperationLog();
  },
  methods: {
    //获取POI类型
    getPOIType() {
      this.config
        .getUValue("ZJMap:POIType", "")
        .then((d) => {
          this.EqTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          this.EqRegionArr = r;
          console.log(r);
          // this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      let searchInfo = {
        DeviceName: this.EqName,
        DeviceType: this.EqType,
        EquipmentType: "MapPOI",
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.TranResourcesApi()
        .GetEquipmentPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/poi/UI/POIManagerEdit",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/poi/ui/POIManagerEdit",
        query: { InfoId: row.DeviceId, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/poi/ui/POIManagerEdit",
        query: { InfoId: row.DeviceId, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.TranResourcesApi()
            .DelEquipment(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.EqName = "";
      this.EqType = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    RegionNumToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const RegionName = this.EqRegionArr.map((item) => {
        if (item.RegionId == data) return item.RegionName;
      }).join("");
      if (RegionName == null || RegionName == "") {
        return data;
      }
      return RegionName;
    },
    EqTypeNumToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const Description = this.EqTypeArr.map((item) => {
        if (item.ItemValue == data) return item.Description;
      }).join("");
      if (Description == null || Description == "") {
        return data;
      }
      return Description;
    },
  },
};
</script>
